import { stdObject } from "../../../../data/types/stdObject";
import { sendData } from "../../../../services/sendData";
import { getCurrentDateTime } from "../../../../utils/getCurrentDateTime";
import { openInventory } from "./openInventory";

export const saveInventory = async (open: boolean, params: stdObject) => {
  const {
    t,
    user,
    customUpdate,
    modalData,
    windowValues,
    setWindowValues,
    setModalData,
    setMsg,
    setMsg2,
    closeMsg,
    logoutAction,
  } = params;

  setMsg2("loading");

  let payloadSaveInventory: stdObject = {
    id: modalData.id,
    date:
      windowValues.FECINV === "" ? getCurrentDateTime() : windowValues.FECINV,
    warehouse: windowValues.ALMINV,
    item: windowValues.ARTINV,
    color: windowValues.COLINV,
    current: windowValues.ACTINV,
    available: windowValues.DISINV,
    observations: windowValues.OBSINV,
  };
  console.log("payloadSaveInventory: ", payloadSaveInventory);
  const responseSaveInventory: stdObject = await sendData({
    endPoint: "saveInventory",
    payload: payloadSaveInventory,
    logoutAction,
  });

  console.log("responseSaveInventory: ", responseSaveInventory);
  const { success, status } = responseSaveInventory;
  if (success && status) {
    customUpdate.current = { mainInfo: "INV" };
    if (open) {
      openInventory("", windowValues.FECINV, {
        t,
        user,
        setWindowValues,
        setModalData,
        setMsg,
        setMsg2,
        closeMsg,
        logoutAction,
      });
    } else {
      closeMsg();
      setWindowValues({});
    }
    closeMsg(2);
  } else {
    setMsg2("error");
  }
};
